import { CwtApiSchema, CwtProp, CwtSchema } from "@cawita/core-front/api";
import { CustomFieldSetFilter } from "./custom-field-set-filter.model";
import { CustomField } from "./custom-field.model";

@CwtSchema()
export class CustomFieldSetStep extends CwtApiSchema {
    @CwtProp() answerPersistancy: number;
    @CwtProp({ ref: CustomField }) customField: CustomField;
    @CwtProp({ ref: CustomFieldSetFilter }) filters: CustomFieldSetFilter[];
}